import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {BarChart} from '@mui/x-charts';
import {XYVO} from "@/service/analyze";

export interface SellerProductAmountProps {
    creators?: XYVO[]
    loading: boolean
}

export default function SellerProductAmount({creators, loading}: SellerProductAmountProps) {
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Typography component="h2" variant="subtitle2" gutterBottom>
                    业务人员产品数量
                </Typography>
                <BarChart
                    // width={200}
                    loading={loading}
                    localeText={{loading: "加载中"}}
                    height={180}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                    hideLegend={true}
                    series={[
                        {data: creators?.map(item => item.y) || [], label: '数量', color: '#A294F9', id: 'pvId'},
                    ]}
                    xAxis={[{
                        categoryGapRatio: 0.6,
                        disableTicks: true,
                        data: creators?.map(item => item.x) || []
                    }]}
                    yAxis={[{width: 26, disableLine: true, disableTicks: true}]}
                />
            </CardContent>
        </Card>
    );
}
